/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getRegisterAddressBookList = (state) => state.mfeCheckout?.member?.addressBook?.addressBookEntries || [];
export const getTotalRegisterAddressBook = (state) => state.mfeCheckout?.member?.addressBook?.totalEntries;
export const getRegisterAddressBookPageNumber = (state) => {
    const { pageNumber } = state.mfeCheckout?.member?.addressBook;
    if (pageNumber) {
        return pageNumber;
    }
    return 0;
};
export const getRegisterAddressBookPages = (state) => state.mfeCheckout?.member?.addressBook?.totalPages;
export const getBillingUserAddressBookInfo = (state) => state.mfeCheckout?.member?.addressBook?.billingAddress;

export default {};
